import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { setPreventNavigation, leaveConfirmationCopy } from '../../../redux/navigate';
import ConfirmationModalNew from '../ConfirmationModalNew';

import './BaseModal.scss';

const Prompt = ({
	children = 'Are you sure you want to leave the page? Your changes will not be saved.',
	handleOK,
	handleCancel,
	title = 'Unsaved changes',
	okText = 'Leave without saving',
	cancelText = 'Keep editing'
}) => (
	<ConfirmationModalNew
		title={title}
		onConfirm={handleOK}
		confirmLabel={okText}
		onPrimaryAction={handleCancel}
		cancelLabel={cancelText}
		onCancel={handleCancel}
		className="router-prompt-modal"
	>
		{children}
	</ConfirmationModalNew>
);

const RouterPrompt = ({ when }) => {
	const history = useHistory();
	const copy = useSelector(leaveConfirmationCopy);

	const [showPrompt, setShowPrompt] = useState(false);
	const [currentPath, setCurrentPath] = useState('');
	const unblockRef = useRef();
	const dispatch = useDispatch();

	const handleShowModal = () => setShowPrompt(true);

	useEffect(() => {
		unblockRef.current = history.block((location) => {
			if (when && location.pathname !== history.location.pathname) {
				setCurrentPath(location.pathname);
				handleShowModal();
				return false;
			}
			return true;
		});
		return () => {
			if (unblockRef.current) {
				unblockRef.current();
			}
		};
	}, [when]);

	const handleOK = () => {
		if (unblockRef) {
			unblockRef.current();
		}
		setShowPrompt(false);
		dispatch(setPreventNavigation(false));
		history.push(currentPath);
	};

	const handleCancel = () => setShowPrompt(false);

	return showPrompt ? (
		<Prompt
			handleOK={handleOK}
			handleCancel={handleCancel}
			title={copy.title}
			okText={copy.confirmLabel}
			cancelText={copy.cancelLabel}
		>
			{copy.message}
		</Prompt>
	) : null;
};

RouterPrompt.BasePrompt = Prompt;

export default RouterPrompt;
